import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { ExcluirParametrosLocalidadeRequest, Types } from './types';

// ACTIONS
import {
	excluirParametrosLocalidadeSuccess,
	excluirParametrosLocalidadeFailure,
} from './actions';

function* excluirParametrosLocalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ExcluirParametrosLocalidadeRequest } = request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_API,
		`v2/parametros-localidades/${payload.sigla}`,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(excluirParametrosLocalidadeSuccess(response));
	} else {
		yield put(excluirParametrosLocalidadeFailure());
	}
}

export default all([
	takeLatest(Types.EXCLUIR_PARAMETROS_LOCALIDADE, excluirParametrosLocalidade),
]);
